document.addEventListener('DOMContentLoaded', () => {
  const productGrid = document.getElementById('product-grid');
  const loadMoreContainer = document.getElementById('load-more-container');
  const loadMoreButton = document.getElementById('load-more');
  const loader = document.getElementById('loader');
  const productCountText = document.getElementById('product-count-text');

  if (loadMoreButton) {
    const totalProducts = parseInt(productGrid.dataset.totalProducts, 10);
    const itemsPerRender = parseInt(productGrid.dataset.totalItemsPerRender, 10);
    const gridColumns = parseInt(productGrid.dataset.gridColumns, 10);
    let loadedProducts = productGrid.querySelectorAll('.product-item').length;

    loadMoreButton.addEventListener('click', () => {
      const nextPageUrl = loadMoreButton.dataset.nextPage;

      if (nextPageUrl) {
        loader.classList.remove('tw-hidden');

        fetch(nextPageUrl)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Fetch new products
            const newProducts = doc.querySelectorAll('.product-item');
            newProducts.forEach(item => productGrid.insertBefore(item, loadMoreContainer));

            // Update loaded product count
            loadedProducts += newProducts.length;

            // Calculate remaining products
            const remainingProducts = totalProducts - loadedProducts;

            // Adjust for grid alignment (ensure multiple of gridColumns)
            const nextLoadCount = Math.min(
              Math.ceil(remainingProducts / gridColumns) * gridColumns,
              remainingProducts
            );

            // Update product count text
            productCountText.innerHTML = `Showing <span class="tw-font-semibold">${loadedProducts}</span> of ${totalProducts}`;

            // Update or remove Load More button
            const newNextPageUrl = doc.getElementById('load-more')?.dataset.nextPage;

            if (newNextPageUrl && remainingProducts > 0) {
              loadMoreButton.dataset.nextPage = newNextPageUrl;
              loadMoreButton.textContent = `Load ${nextLoadCount} More`;
            } else {
              loadMoreButton.remove();
            }
          })
          .catch(error => console.error('Error loading more products:', error))
          .finally(() => loader.classList.add('tw-hidden'));
      }
    });
  }
});